import { ZonesTabs } from './zones-tabs';
import { Content, Inner } from './rules-card.styled';

export const RulesCard = ({ refresh, item, rule }) => {
  return (
    <Content>
      <Inner>
        <ZonesTabs refresh={refresh} selectedZoneId={item.zone_id} type={rule.type} zones={rule.zones || []} ruleId={rule.rule_id} />
      </Inner>
    </Content>
  );
};
